/**
 * A paralax effect using top
 */
angular.module('pitch.app')
.directive('paralaxTop', function(BrowserTools, $window/*, $timeout*/) {
    "use strict";
    return {
        restrict: 'A',
        scope: {
            active: '='
        },
        link: function($scope, elem, attr, ctrl) {
            var scrolltop, val, win, el, elTop, max, factor, isAnimating;

            if (!$window.requestAnimationFrame) {
                return;
            }

            factor = parseInt(attr.paralaxTop);
            win = angular.element($window);
            el  = angular.element(elem);

            function handleScroll() {
                scrolltop = BrowserTools.getScrollTop();
                if (!isAnimating && $scope.active) {
                    // $timeout(function() {
                        $window.requestAnimationFrame(function() {
                            setPosition();
                            isAnimating = false;
                        });
                    // }, 1000 / 15);
                }
            }

            function setPosition() {
                el.css('transform', 'translate3d(0, ' + (scrolltop / factor).toFixed() + 'px, 0)');
            }

            $scope.$watch('active', function(v) {
                if (v) {
                    scrolltop = BrowserTools.getScrollTop();
                    setPosition();
                }
            });

            win.on("scroll", handleScroll);

            $scope.$on('$destroy', function() {
                win.off("scroll", handleScroll);
            });
        }
    };
})
;



// WEBPACK FOOTER //
// ./src/AppBundle/Resources/js/angular/directives/paralaxTop.js